
// src/components/Auth/LoginForm.js
import React, { useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

const LoginForm = () => {
    const [credentials, setCredentials] = useState({
        username: '',
        password: '',
    });
    const [errors, setErrors] = useState({});

    const { login, loading, error } = useAuthStore();
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const validate = () => {
        const newErrors = {};
        if (!credentials.username) {
            newErrors.username = 'Email je povinný';
        } else if (!/\S+@\S+\.\S+/.test(credentials.username)) {
            newErrors.username = 'Neplatný email';
        }

        if (!credentials.password) {
            newErrors.password = 'Heslo je povinné';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        try {
            await login(credentials);
            navigate('/dashboard');
        } catch (error) {
            // Chyby jsou již zpracovány v store
        }
    };

    return (
        <Form onSubmit={handleSubmit}>
            {error && <Alert variant="danger">{error}</Alert>}

            <Form.Group className="mb-3">
                <Form.Label>E-mail</Form.Label>
                <Form.Control
                    type="email"
                    name="username"
                    value={credentials.username}
                    onChange={handleChange}
                    placeholder="vas@email.cz"
                    isInvalid={!!errors.username}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.username}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-4">
                <Form.Label>Heslo</Form.Label>
                <Form.Control
                    type="password"
                    name="password"
                    value={credentials.password}
                    onChange={handleChange}
                    isInvalid={!!errors.password}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.password}
                </Form.Control.Feedback>
                {/*
                <div className="d-flex justify-content-end mt-1">
                    <Link to="/forgot-password" className="text-small">Zapomenuté heslo?</Link>
                </div>
                */}
            </Form.Group>

            <div className="d-grid mb-4">
                <Button
                    type="submit"
                    variant="primary"
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                            Přihlašuji...
                        </>
                    ) : 'Přihlásit se'}
                </Button>
            </div>

            <div className="text-center d-none">
                <span className="text-muted text-small">Nemáte účet? </span>
                <Link to="/register">Zaregistrujte se</Link>
            </div>
        </Form>
    );
};

export default LoginForm;